/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateRule.defs.js'
export * as $defs from './updateRule.defs.js'
